// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Y0gL","header":"PatientBlock_header__1tDsP","label":"PatientBlock_label__3RVLZ","option":"PatientBlock_option__2W8h6"};